import { render, staticRenderFns } from "./simple-notes.vue?vue&type=template&id=5f282720"
import script from "./simple-notes.vue?vue&type=script&lang=ts"
export * from "./simple-notes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports